/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Milling_ProcessInputs */

const en_milling_process = /** @type {(inputs: Milling_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milling Process`)
};

const es_milling_process = /** @type {(inputs: Milling_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceso de beneficio`)
};

/**
* | output |
* | --- |
* | "Milling Process" |
*
* @param {Milling_ProcessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const milling_process = /** @type {((inputs?: Milling_ProcessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Milling_ProcessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_milling_process(inputs)
	return es_milling_process(inputs)
});